module.exports = __webpack_public_path__ + "img/通威集团.53fb9d5c.png";